(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-vertical-bar"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-vertical-bar"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_39__, __WEBPACK_EXTERNAL_MODULE_93__, __WEBPACK_EXTERNAL_MODULE_120__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 192);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var shared = __webpack_require__(35);
var hasOwn = __webpack_require__(6);
var uid = __webpack_require__(47);
var NATIVE_SYMBOL = __webpack_require__(46);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(2);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toObject = __webpack_require__(16);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(53);
var anObject = __webpack_require__(8);
var toPropertyKey = __webpack_require__(22);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(33);
var requireObjectCoercible = __webpack_require__(21);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(41).f;
var createNonEnumerableProperty = __webpack_require__(13);
var redefine = __webpack_require__(18);
var setGlobal = __webpack_require__(25);
var copyConstructorProperties = __webpack_require__(70);
var isForced = __webpack_require__(69);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__(61);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var requireObjectCoercible = __webpack_require__(21);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var hasOwn = __webpack_require__(6);
var createNonEnumerableProperty = __webpack_require__(13);
var setGlobal = __webpack_require__(25);
var inspectSource = __webpack_require__(26);
var InternalStateModule = __webpack_require__(44);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(42).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__(71);
var isSymbol = __webpack_require__(43);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var userAgent = __webpack_require__(59);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var setGlobal = __webpack_require__(25);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var isCallable = __webpack_require__(2);
var store = __webpack_require__(24);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var classof = __webpack_require__(32);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var isCallable = __webpack_require__(2);
var classofRaw = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var classof = __webpack_require__(17);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(55);
var store = __webpack_require__(24);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(22);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var fails = __webpack_require__(3);
var isArray = __webpack_require__(31);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);
var arraySpeciesCreate = __webpack_require__(48);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var call = __webpack_require__(12);
var propertyIsEnumerableModule = __webpack_require__(67);
var createPropertyDescriptor = __webpack_require__(20);
var toIndexedObject = __webpack_require__(10);
var toPropertyKey = __webpack_require__(22);
var hasOwn = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(53);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var hasOwn = __webpack_require__(6);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getBuiltIn = __webpack_require__(14);
var isCallable = __webpack_require__(2);
var isPrototypeOf = __webpack_require__(54);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(74);
var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var isObject = __webpack_require__(5);
var createNonEnumerableProperty = __webpack_require__(13);
var hasOwn = __webpack_require__(6);
var shared = __webpack_require__(24);
var sharedKey = __webpack_require__(45);
var hiddenKeys = __webpack_require__(27);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(35);
var uid = __webpack_require__(47);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(23);
var fails = __webpack_require__(3);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(77);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var redefine = __webpack_require__(18);
var toString = __webpack_require__(80);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(32);
var getBuiltIn = __webpack_require__(14);
var inspectSource = __webpack_require__(26);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(46);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var fails = __webpack_require__(3);
var createElement = __webpack_require__(36);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var hasOwn = __webpack_require__(6);
var toIndexedObject = __webpack_require__(10);
var indexOf = __webpack_require__(76).indexOf;
var hiddenKeys = __webpack_require__(27);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(83);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var arraySpeciesCreate = __webpack_require__(48);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__(50);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(8);
var defineProperties = __webpack_require__(90);
var enumBugKeys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(27);
var html = __webpack_require__(91);
var documentCreateElement = __webpack_require__(36);
var sharedKey = __webpack_require__(45);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DOMIterables = __webpack_require__(78);
var DOMTokenListPrototype = __webpack_require__(79);
var forEach = __webpack_require__(86);
var createNonEnumerableProperty = __webpack_require__(13);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var toString = __webpack_require__(30);
var regexpFlags = __webpack_require__(87);
var stickyHelpers = __webpack_require__(92);
var shared = __webpack_require__(35);
var create = __webpack_require__(63);
var getInternalState = __webpack_require__(44).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(102);
var UNSUPPORTED_NCG = __webpack_require__(103);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__(6);
var ownKeys = __webpack_require__(75);
var getOwnPropertyDescriptorModule = __webpack_require__(41);
var definePropertyModule = __webpack_require__(9);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isObject = __webpack_require__(5);
var isSymbol = __webpack_require__(43);
var getMethod = __webpack_require__(60);
var ordinaryToPrimitive = __webpack_require__(73);
var wellKnownSymbol = __webpack_require__(4);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isCallable = __webpack_require__(2);
var isObject = __webpack_require__(5);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var inspectSource = __webpack_require__(26);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);
var uncurryThis = __webpack_require__(1);
var getOwnPropertyNamesModule = __webpack_require__(62);
var getOwnPropertySymbolsModule = __webpack_require__(68);
var anObject = __webpack_require__(8);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(36);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var classof = __webpack_require__(32);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var FUNCTION_NAME_EXISTS = __webpack_require__(42).EXISTS;
var uncurryThis = __webpack_require__(1);
var defineProperty = __webpack_require__(9).f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var aCallable = __webpack_require__(50);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var toIndexedObject = __webpack_require__(10);
var createProperty = __webpack_require__(38);
var wellKnownSymbol = __webpack_require__(4);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var un$Slice = __webpack_require__(88);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toIndexedObject = __webpack_require__(10);
var arrayMethodIsStrict = __webpack_require__(58);

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(57).forEach;
var arrayMethodIsStrict = __webpack_require__(58);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis([].slice);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var exec = __webpack_require__(66);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var anObject = __webpack_require__(8);
var toIndexedObject = __webpack_require__(10);
var objectKeys = __webpack_require__(82);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_93__;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(10);
var addToUnscopables = __webpack_require__(111);
var Iterators = __webpack_require__(94);
var InternalStateModule = __webpack_require__(44);
var defineIterator = __webpack_require__(115);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var $filter = __webpack_require__(57).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 98 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(9).f;
var hasOwn = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toIntegerOrInfinity = __webpack_require__(19);
var toString = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(21);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var $map = __webpack_require__(57).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(89);
var uncurryThis = __webpack_require__(1);
var redefine = __webpack_require__(18);
var regexpExec = __webpack_require__(66);
var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var createNonEnumerableProperty = __webpack_require__(13);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(100).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var anObject = __webpack_require__(8);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(17);
var regexpExec = __webpack_require__(66);

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);
var create = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(108);
var redefine = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(4);
var IS_PURE = __webpack_require__(55);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var hasOwn = __webpack_require__(6);
var isCallable = __webpack_require__(2);
var toObject = __webpack_require__(16);
var sharedKey = __webpack_require__(45);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(122);

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__(1);
var anObject = __webpack_require__(8);
var aPossiblePrototype = __webpack_require__(112);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var classof = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);
var create = __webpack_require__(63);
var definePropertyModule = __webpack_require__(9);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DOMIterables = __webpack_require__(78);
var DOMTokenListPrototype = __webpack_require__(79);
var ArrayIteratorMethods = __webpack_require__(96);
var createNonEnumerableProperty = __webpack_require__(13);
var wellKnownSymbol = __webpack_require__(4);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var call = __webpack_require__(12);
var IS_PURE = __webpack_require__(55);
var FunctionName = __webpack_require__(42);
var isCallable = __webpack_require__(2);
var createIteratorConstructor = __webpack_require__(121);
var getPrototypeOf = __webpack_require__(108);
var setPrototypeOf = __webpack_require__(109);
var setToStringTag = __webpack_require__(99);
var createNonEnumerableProperty = __webpack_require__(13);
var redefine = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(4);
var Iterators = __webpack_require__(94);
var IteratorsCore = __webpack_require__(107);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var toIntegerOrInfinity = __webpack_require__(19);
var lengthOfArrayLike = __webpack_require__(15);
var toObject = __webpack_require__(16);
var arraySpeciesCreate = __webpack_require__(48);
var createProperty = __webpack_require__(38);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError = global.TypeError;
var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(98);
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(104);
var isRegExp = __webpack_require__(110);
var anObject = __webpack_require__(8);
var requireObjectCoercible = __webpack_require__(21);
var speciesConstructor = __webpack_require__(118);
var advanceStringIndex = __webpack_require__(105);
var toLength = __webpack_require__(61);
var toString = __webpack_require__(30);
var getMethod = __webpack_require__(60);
var arraySlice = __webpack_require__(95);
var callRegExpExec = __webpack_require__(106);
var regexpExec = __webpack_require__(66);
var stickyHelpers = __webpack_require__(92);
var fails = __webpack_require__(3);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var aConstructor = __webpack_require__(119);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isConstructor = __webpack_require__(51);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_120__;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(107).IteratorPrototype;
var create = __webpack_require__(63);
var createPropertyDescriptor = __webpack_require__(20);
var setToStringTag = __webpack_require__(99);
var Iterators = __webpack_require__(94);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(193);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(194);

var _barChart = _interopRequireDefault(__webpack_require__(195));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _barChart.default;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);

__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(81);

__webpack_require__(96);

__webpack_require__(113);

__webpack_require__(97);

__webpack_require__(40);

__webpack_require__(89);

__webpack_require__(117);

__webpack_require__(84);

__webpack_require__(116);

__webpack_require__(85);

var Core = __webpack_require__(39);

var Legend = __webpack_require__(120);

var Benchmarks = __webpack_require__(196);

var Tooltip = __webpack_require__(197);

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;
var DateAxis = Core.Axes.DateAxis;
var mbc_mds_constants = Utils.colors.mbc_mds_constants;
/**
 * Vertical Bar Chart.
 *
 * @example
 * // Extension example:
 * var BarChart = require("mbc-bar-chart");
 *
 * var NewExtendedBarChart = BarChart.extend({
 *   ...
 * });
 *
 * @example
 * // Use example:
 * var BarChart = require("mbc-bar-chart");
 *
 * var barchart = new BarChart(<options>);
 * d3Container.datum(data).call(barchart.init());
 *
 * @class
 * @extends Chart
 */

var GroupedBarchart = Chart.extend(Benchmarks, Legend, Tooltip,
/**
 * @lends GroupedBarchart.prototype
 **/
{
  /** @type {String} */
  id: "mbc-vertical-bar-chart",
  // Also used as class for this chart type.

  /** @type {Number} */
  screenMinHeight: 100,
  // container min-height

  /** @type {Number} */
  benchmarksHeight: 2,

  /** @type {String} */
  benchmarksColor: mbc_mds_constants["color"].black,

  /** @type {String} */
  benchmarksDataSource: "Benchmarks",

  /** @type {String} */
  benchmarksDisplayName: "Benchmarks",

  /** @type {Number} */
  breakpoint: 600,

  /** @type {Number} */
  customBarPadding: null,

  /** @type {Boolean} */
  hasBenchmarks: false,

  /** @type {Boolean} */
  legend: true,

  /** @type {Number} */
  legendMaxWidth: 150,

  /** @type {Boolean} */
  stacked: false,

  /** @type {Number} */
  ticksNumber: 4,

  /** @type {Boolean} */
  ticksSymmetrical: true,

  /** @type {Array} */
  tickValues: null,

  /** @type {Array} */
  x0Domain: null,

  /** @type {String} */
  xAxisOrient: "bottom",

  /** @type {Boolean} */
  wrapXAxisLabels: false,
  //  Allows X-axis labels to wrap to a maximum of three lines and then truncate. NOTE: To achieve this within the current chart architecture, the chart plot has been resized to always provide the space need for 3 lines of wrapping

  /** @type {Number} */
  _wrapXAxisLabelsCanvasAdjustment: 35,
  // Adjust canvas size to account for extra lines from wrap() method

  /** @type {Array} */
  xAxisLabels: null,

  /** @type {String} */
  xAxisLabelsDatasource: "xLabels",

  /** @type {Array} */
  xDomain: null,

  /** @type {String} */
  xDomainDatasource: "xDomain",

  /** @type {Boolean} **/
  xAxisDateLabel: false,

  /** @type {String} **/
  timeLevel: 'monthly',

  /** @type {String} */
  y1Abbreviation: null,

  /** @type {Boolean|String} */
  y1AxisLabel: false,

  /** @type {String} */
  y1AxisOrient: "left",

  /** @type {String} */
  y1DataSource: "y1AxisData",

  /** @type {String} */
  y1TicksAlign: "right",

  /** @type {Function|String} */
  y1TickFormat: ",.2f",

  /** @type {String} */
  y1TickSymbol: "$",

  /** @type {Boolean} */
  y2: false,

  /** @type {String} */
  y2Abbreviation: null,

  /** @type {Boolean} */
  y2AxisLabel: false,

  /** @type {String} */
  y2AxisOrient: "left",

  /** @type {String} */
  y2DataSource: "y2AxisData",

  /** @type {String} */
  y2TicksAlign: "right",

  /** @type {Function|String} */
  y2TickFormat: ",.2f",

  /** @type {String} */
  y2TickSymbol: "$",

  /** @type {Number} */
  yAxesLabelWidth: 15,

  /** @type {Number} */
  yAxesLabelPadding: 3,

  /** @type {Number} */
  yAxesSpacing: 12,

  /** @type {Array} */
  yDomain: null,

  /** @type {Number} */
  yPadding: 12,

  /** @type {Number} */
  yPaddingBig: 12,

  /** @type {Number} */
  yPaddingSmall: 6,

  /** @type {Number} */
  yTickMargin: 6,

  /** @type {Number} */
  yTickSize: 35,

  /** @type {Boolean} */
  tooltip: true,

  /** @type {Number} */
  tooltipDecimals: 2,

  /** @type {String}*/
  tooltipTemplate: '',

  /** @type {Function}*/
  tooltipTemplateFunction: null,

  /** @type {Object} */
  tooltipNullValueDisplay: "N/A",

  /** @type {Boolean} */
  defaultBenchmarkStyle: true,

  /** @type {Boolean} */
  hideBars: false,

  /** @type {Number} */
  dottedStrokeWidth: 2,

  /** @type {String} */
  dottedDashDimensions: "1, 5",

  /** @type {Boolean} */
  dottedBenchmarks: false,

  /** @type {Boolean} */
  showGrayBands: false,
  //config whether show gray bands.

  /** @type {Number} */
  y1TickWidth: 0,
  //config axis-y1 width, if not passing this value, chart will calculate  appropriate width.

  /** @type {Boolean} */
  showZeroLine: true,
  //Control grid zero line opacity
  allowDuplicateDataGroups: false,
  //Allows data groups to have same name but plot in different groups
  showLabelsAtBreakpoint: false,
  //show the x-axis labels at small breakpoint
  showSubLabelsAtBreakpoint: false,

  /**
   * @override
   * Prepare the data for the chart.
   * @param {Object} data Raw data.
   */
  setData: function setData(data) {
    var _this = this;

    var dataManager = this.get("data");
    var benchmarksSource = this.get("benchmarksDataSource");
    var benchmarksData = Utils.object.path(data, benchmarksSource);
    var xAxisLabels = Utils.object.path(data, this.get("xAxisLabelsDatasource"));
    this.set("xDomain", Utils.object.path(data, this.get("xDomainDatasource")).map(function (d, i) {
      return Utils.string.mask(d, i);
    }));

    if (!Utils.array.hasNulls(xAxisLabels)) {
      this.set("xAxisLabels", xAxisLabels);
    }

    Utils.object.path(data, this.get("y1DataSource")).forEach(function (sObject) {
      dataManager.set(sObject.name, sObject.values, this.get("y1DataSource"));
    }.bind(this));
    dataManager.parser(this.get("y1DataSource"), function (data, domain) {
      var map = domain.map(function (point, i) {
        var obj = {
          point: point
        };
        var values = data;
        var positive;
        var negative;

        if (_this.get("stacked")) {
          positive = data.filter(function (value) {
            return value.series[i] >= 0;
          }).reverse();
          negative = data.filter(function (value) {
            return value.series[i] < 0;
          });
          values = negative.concat(positive);
        }

        obj.values = values.map(function (value) {
          return {
            point: point,
            series: value.name,
            value: value.series[i],
            index: value.index
          };
        });
        return obj;
      });
      return map;
    }, this.get("xDomain"));

    if (benchmarksData) {
      this.set("benchmarksDisplayName", benchmarksData.name);
      this.get("data").uset({
        name: benchmarksSource,
        series: benchmarksData.values,
        display: benchmarksData.name
      });
    }
  },

  /**
   * @method wrap
   * Wraps text to multiple lines as needed according to bar width
   * @param text
   */
  wrap: function wrap(text, wrapVars) {
    var layer = wrapVars.get("canvas").layer(wrapVars.get("id"));
    var group = layer.selectAll(".bar-group");
    var barWidth = group.selectAll("rect").attr("width");
    var wraplineLimit = 3;
    text.each(function () {
      var text = d3.select(this),
          textWidth,
          words = text.text().split(/\s+/).reverse(),
          word,
          line = [],
          lineHeight = 1.2,
          lineNumber = 0,
          x = 0,
          y = text.attr("y"),
          dy = parseFloat(text.attr("dy")),
          tspan = text.text(null),
          ellipsis = "...",
          linesArr = [];

      if (isNaN(dy)) {
        dy = 0;
        x = text.attr("x");
      } // Find all the individual words that are wider than the bar max width
      // Split them into fragments that will fit the width of the bar


      var wordsArrayClone = words.slice();

      for (var i = 0; i < wordsArrayClone.length; i++) {
        var fragments;
        var indexOfWord;
        textWidth = Utils.string.getTextWidth(wordsArrayClone[i], 'sans-serif', '14px');

        if (textWidth > barWidth) {
          fragments = Utils.string.breakString(wordsArrayClone[i], textWidth, barWidth).reverse();
          indexOfWord = words.indexOf(wordsArrayClone[i]);
          words.splice.apply(words, [indexOfWord, 1].concat(fragments));
        }
      } // Create new lines


      while (word = words.pop()) {
        line.push(word); // create a new line if text width is larger than the bar width

        var textWidth = Utils.string.getTextWidth(line.join(" "));

        if (textWidth > barWidth) {
          line.pop();

          if (line.length > 0) {
            linesArr.push(line.join(" "));
          }

          line = [word];
        }
      }

      if (line.length > 0) {
        linesArr.push(line.join(" "));
      }

      if (linesArr.length === 0) {
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", lineNumber * lineHeight + dy + "em").text(line.join(" "));
        return;
      } else {
        // Append lines to tspans upto wraplineLimit or linesArray whichever is smaller
        var tspanLimit = linesArr.length < wraplineLimit ? linesArr.length : wraplineLimit;

        for (var i = 0; i < tspanLimit; i++) {
          var lineStr = linesArr[i]; // Add ellipsis

          if (linesArr.length > tspanLimit) {
            if (i === tspanLimit - 1) {
              lineStr = lineStr.substring(0, 14) + ellipsis;
            }
          }

          tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", lineNumber * lineHeight + dy + "em").text(lineStr);
          lineNumber++;
        }
      }
    });
  },

  /**
   * @method canvasHeight
   * Returns canvas height
   */
  canvasHeight: function canvasHeight() {
    var canvas = this.get("canvas");
    var adjustCanvasHeight = this.get("_wrapXAxisLabelsCanvasAdjustment");
    var canvasHeight;

    if (this.get("wrapXAxisLabels") === true) {
      canvasHeight = canvas.height() - adjustCanvasHeight;
    } else {
      canvasHeight = canvas.height();
    }

    return canvasHeight;
  },

  /**
   * @method tspanLengthCounter
   * Gives the length of tspan from x-axis label and only applicable when wrap method is applied
   */
  tspanLengthCounter: function tspanLengthCounter() {
    var tspanArrLength = [];
    var tspanCounter;
    var chartID = this.get('UID'); // Find the largest number of tspans in x-axis amongst all bars

    d3.selectAll("." + chartID + " .mbc-axis.mbc-axis-x .tick text").each(function () {
      var el = d3.select(this);
      var tspanLength = el[0][0].childNodes.length;
      tspanArrLength.push(tspanLength);
    });
    tspanCounter = Math.max.apply(Math, tspanArrLength);
    return tspanCounter;
  },

  /**
   * @override
   */
  beforeDraw: function beforeDraw() {
    this.redoCanvas();
    var dataManager = this.get("data");
    var canvas = this.get("canvas");
    var tickValues = this.get("tickValues");
    var y1LabelText = this.get("y1AxisLabel");
    var y2LabelText = this.get("y2AxisLabel");
    var yAxesLabelWidth = this.get("yAxesLabelWidth");
    var yDomain = this.get("yDomain");
    var domain;

    if (!y1LabelText && !y2LabelText) {
      canvas.set("yAxesLabelWidth", 0);
    } else {
      canvas.set("yAxesLabelWidth", yAxesLabelWidth);
    }

    canvas.set("tickSize", this.get("yTickSize"));
    canvas.set("axesSpacing", this.get("yAxesSpacing"));
    canvas.set("axesPadding", this.get("yPadding"));
    canvas.set("margin", this.getMargins());

    if (!yDomain && (!tickValues || tickValues.length < 2)) {
      domain = dataManager.calculateDomain({
        groups: [this.get("y1DataSource"), this.get("benchmarksDataSource")],
        symmetrical: this.get("ticksSymmetrical"),
        steps: this.get("ticksNumber"),
        stacked: this.get("stacked")
      });
      this.set("_yDomain", domain);
    } else if (!yDomain) {
      this.set("_yDomain", [tickValues[0], tickValues[tickValues.length - 1]]);
    } else {
      this.set("_yDomain", yDomain);
    }

    if (this.get("y2")) {
      this.set("y2Domain", [0, 100]);
    } else {
      this.get("axes").remove("y2");
    }

    if (canvas.get("outerWidth") <= this.get("breakpoint")) {
      this.set("yPadding", this.get("yPaddingSmall"));
    } else {
      this.set("yPadding", this.get("yPaddingBig"));
    }

    this.set("x0Domain", this.getX0Domain());

    if (this.get("customBarPadding")) {
      var barPadding = this.get("customBarPadding");
      this.set("barGroupPadding", barPadding);
    } else {
      this.setBarGroupPadding();
    }
  },

  /**
   * @override
   */
  draw: function draw() {
    var wrapXAxisLabels = this.get("wrapXAxisLabels");

    if (this.get("legend")) {
      var dataManager = this.get("data");
      var bars = dataManager.queryGroup(this.get("y1DataSource"));
      var benchmarks = dataManager.queryGroup(this.get("benchmarksDataSource"));
      var data = bars.concat(benchmarks);
      this.invokeLegend({
        chart: "verticalBar",
        data: data,
        benchmarkStyle: this.get("dottedBenchmarks"),
        benchmarkColor: this.get("benchmarksColor"),
        benchmarkSpan: "benchmarks"
      });
      this.get("canvas").update();
    }

    this.buildScales();
    this.drawBars();
    this.buildAxes();
    this.drawAxes();
    this.drawGrid();

    if (wrapXAxisLabels) {
      // Wrap long labels
      var text = this.get("canvas").get("axesGroup").selectAll(".".concat(Classes.AXIS, "-x text"));
      this.wrap(text, this);
    }

    if (this.get("tooltip")) {
      this.initTooltip();
    }
  },

  /**
   * @override
   */
  afterDraw: function afterDraw(options) {
    var _this = this;

    var canvas = this.get("canvas");
    var axes = canvas.get("axesGroup");
    var xAxisOrient = this.get("xAxisOrient");
    var noTicksRecalc = options && options.noTicksRecalc;
    var domain, first, last, height;
    var subLabels = this.get('xAxisLabels');
    var xTexts = canvas.layer("".concat(Classes.AXES, "-xlabels"), "axes").selectAll(".mbc-x-label");
    var xScale = this.get("scales").scale("x");
    var wrapXAxisLabels = this.get("wrapXAxisLabels");
    var canvasHeight = this.canvasHeight();
    var tspanCounter = this.tspanLengthCounter();
    var adjustSubLabels = tspanCounter > 1 ? 69 : 35;
    var adjustCanvasHeight = this.get("_wrapXAxisLabelsCanvasAdjustment");
    this.adjustYLabels();
    var showBars = this.get("showLabelsAtBreakpoint");
    var showSubLabels = this.get('showSubLabelsAtBreakpoint');

    if (!this.get("xAxisDateLabel") && canvas.get("outerWidth") <= this.get("breakpoint") && !showBars) {
      axes.selectAll(".".concat(Classes.AXIS, "-x text")).style("display", "none");
      domain = this.get("xDomain");
      first = Utils.string.unmask(domain[0]);
      last = Utils.string.unmask(domain[domain.length - 1]);
      height = this.canvasHeight() + 15;

      if (wrapXAxisLabels === true) {
        axes.append("text").attrs({
          x: 5,
          y: xAxisOrient === "bottom" ? height : -9,
          class: "x-alternative-first",
          "text-anchor": "start"
        }).text(first).call(_this.wrap, _this);
        axes.append("text").attrs({
          x: canvas.width() - 6,
          y: xAxisOrient === "bottom" ? height : -9,
          class: "x-alternative-last",
          "text-anchor": "end"
        }).text(last).call(_this.wrap, _this);
      } else {
        axes.append("text").attrs({
          x: 5,
          y: xAxisOrient === "bottom" ? height : -9,
          class: "x-alternative-first",
          "text-anchor": "start"
        }).text(first);
        axes.append("text").attrs({
          x: canvas.width() - 6,
          y: xAxisOrient === "bottom" ? height : -9,
          class: "x-alternative-last",
          "text-anchor": "end"
        }).text(last);
      }

      if (subLabels) {
        if (!showSubLabels && subLabels.length) {
          var firstSubLabel = Utils.string.unmask(subLabels[0]);
          var lastSublabel = Utils.string.unmask(subLabels[subLabels.length - 1]);
          height = tspanCounter > 1 ? canvasHeight + adjustSubLabels : canvasHeight + 32;
          axes.append("text").attrs({
            x: 5,
            y: xAxisOrient === "bottom" ? height : -29,
            class: "x-alternative-first--sub mbc-x-label",
            "text-anchor": "start"
          }).text(firstSubLabel);
          axes.append("text").attrs({
            x: canvas.width() - 6,
            y: xAxisOrient === "bottom" ? height : -29,
            class: "x-alternative-last--sub mbc-x-label",
            "text-anchor": "end"
          }).text(lastSublabel);
        }
      }
    } // adjust x-axis labels when wrap method called


    var xAxisBottom = canvas.get("axesGroup").select(".mbc-axis-bottom");

    if (tspanCounter > 0) {
      xAxisBottom.attr("transform", "translate(0, " + canvasHeight + ")");
    } // adjust sublabels when wrap method called


    if (tspanCounter > 1) {
      xTexts.attr("transform", function (d) {
        var x = xScale(d) + xScale.rangeBand() / 2;
        var y = xAxisOrient === "bottom" ? canvasHeight + adjustSubLabels : -25;
        return "translate(".concat(x, ", ").concat(y, ")");
      });
    }

    if (this.get("legend")) {
      canvas.watch("outerWidth", function (newValue, oldValue) {
        this.checkBreakpoints(newValue, oldValue);
      }.bind(this));
      this.adjustLegendHeight(); // Adjust legend height when wrap method called

      if (this.get("legend") && wrapXAxisLabels) {
        var container = this.get("selection").select("." + Classes.LEGEND);

        if (container.classed(Classes.LEGEND + "-right")) {
          container.style({
            height: canvas.height() - adjustCanvasHeight + "px"
          });
        }
      }
    }

    if (!noTicksRecalc) {
      this.updateTickWidths(axes);
    }
  },

  /**
   * To render the middle tick line on Y-axes when domain range is negative to positive
   */
  addYAxisCenterTick: function addYAxisCenterTick() {
    var canvas = this.get("canvas");
    var axisY1 = canvas.layer("mbc-axis-y1", "axes").selectAll(".tick")[0];
    var axisY2 = canvas.layer("mbc-axis-y2", "axes").selectAll(".tick")[0];
    var domain = this.get("_yDomain");
    var tickValues = this.get("tickValues") || Utils.chart.getTickValues(this.get("_yDomain"));
    var middleTickIndex = Math.floor(tickValues.length / 2);
    var negativePositiveDomain = domain[0] < 0 && domain[1] > 0;

    if (axisY1 && axisY1.length && negativePositiveDomain && canvas.get("outerHeight") < 200) {
      for (var i = 0; i < axisY1.length; i++) {
        if (i === middleTickIndex) {
          axisY1[i].setAttribute("class", axisY1[i].getAttribute("class") + " middle-tick");

          if (axisY2 && axisY2.length) {
            axisY2[i].setAttribute("class", axisY2[i].getAttribute("class") + " middle-tick");
          }
        }
      }
    }
  },

  /**
   * This method is intended for Y axes tick width recalculation.
   */
  updateTickWidths: function updateTickWidths(axes) {
    var maxWidth = 0;
    var ticks = [];
    var y1TickWidth = this.get('y1TickWidth');
    var el;
    var chartID = this.get('UID');

    if (y1TickWidth) {
      this.set("yTickSize", y1TickWidth);
    } else {
      d3.selectAll("." + chartID + " .mbc-axis.mbc-axis-y1 .tick text").each(function () {
        el = d3.select(this);
        ticks.push(el.text());
      });
      maxWidth = Utils.svg.getGreaterSVGTextWidth(axes.select(".".concat(Classes.AXIS, "-x")), ticks);
      this.set("yTickSize", maxWidth + this.get("yTickMargin"));
    }

    this.set("ticksUpdated", true);
    this.update({
      noTicksRecalc: true
    });
  },

  /**
   * Get the data and call for draw stacked or gruped bar chart as stated in 'stacked' attribute.
   */
  drawBars: function drawBars() {
    var data = this.get("data").get(this.get("y1DataSource"));
    var benchmarks = this.get("data").get(this.get("benchmarksDataSource"));
    var scales = this.get("scales");
    var layer = this.get("canvas").layer(this.get("id"));
    var group = layer.selectAll(".bar-group").data(data);

    if (this.get("stacked")) {
      layer.classed({
        stacked: true,
        grouped: false
      });
      data = this.stackValues(data);
      this.drawStackedBars(data, scales, group);
    } else {
      layer.classed({
        stacked: false,
        grouped: true
      });
      this.drawGroupedBars(data, scales, group);
    }

    this.set("dataForTooltips", data);

    if (benchmarks.length) {
      if (this.get("defaultBenchmarkStyle") === true) {
        this.set("dottedBenchmarks", false);
        this.drawSegmentedBenchmarks(benchmarks);
      } else {
        this.set("dottedBenchmarks", true);
        this.drawBenchmarks(benchmarks);
      }
    } else {
      this.get("canvas").layer("layer-benchmarks").remove();
    }
  },

  /**
   * This method add a stacked value for each positives and negatives point values.
   * This values are setted on 'value0' attribute for positives and 'value1' for negatives;
   * @param {Array} data Contains all series values by Data Point (X axis)
   * @return {Array} The same array with the stacked values added to each point values.
   */
  stackValues: function stackValues(data) {
    return data.map(function (d) {
      var negative = 0; // last values

      var positive = 0;
      d.values = d.values.map(function (value) {
        value.value0 = positive;
        value.value1 = negative;

        if (value.value >= 0) {
          positive += value.value;
        } else if (value.value < 0) {
          negative += value.value;
        }

        return value;
      });
      return d;
    });
  },

  /**
   * Draws the stacked bar chart bars.
   */
  drawStackedBars: function drawStackedBars(data, scales, group) {
    var xScale = scales.scale("x");
    var yScale = scales.scale("y1");
    var bars, heightFn, yFn, fill;
    var barPadding = this.get("barGroupPadding");

    fill = function (d) {
      return this.color(d.index);
    }.bind(this);

    heightFn = function heightFn(d) {
      if (d.value >= 0) {
        return yScale(d.value0) - yScale(d.value0 + d.value);
      } else {
        return Math.abs(yScale(d.value1) - yScale(d.value + d.value1));
      }
    };

    yFn = function yFn(d) {
      if (d.value >= 0) {
        return yScale(d.value0 + d.value);
      } else {
        return yScale(d.value1);
      }
    };

    group.enter().append("g").attr("class", "bar-group");
    group.exit().remove();
    bars = group.selectAll("rect").data(function (d) {
      return d.values;
    }).attr("id", "");
    bars.attrs({
      width: xScale.rangeBand() - barPadding,
      x: function (d) {
        return xScale(d.point) + barPadding / 2;
      }.bind(this),
      y: yFn,
      height: heightFn,
      opacity: this.get("hideBars") ? 0 : 0.8,
      fill: fill.bind(this)
    });
    bars.enter().append("rect").attrs({
      width: xScale.rangeBand() - barPadding,
      x: function (d) {
        return xScale(d.point) + barPadding / 2;
      }.bind(this),
      y: yFn,
      height: heightFn,
      opacity: this.get("hideBars") ? 0 : 0.8,
      fill: fill.bind(this)
    }).on("mouseover", this.get("dispatch").hover).on("mouseout", this.get("dispatch").mouseout).on("click", this.get("dispatch").click);
    bars.exit().remove();
  },

  /**
   * Draws the grouped chart bars.
   */
  drawGroupedBars: function drawGroupedBars(data, scales, group) {
    var _this = this;

    var x0Scale = scales.scale("x0");
    var xScale = scales.scale("x");
    var yScale = scales.scale("y1");
    var barPadding = this.get("barGroupPadding");
    var bars, fill;

    fill = function fill(d) {
      return this.color(d.index);
    };

    group.enter().append("g").attr("class", "bar-group").attr("transform", function (d) {
      return "translate(" + xScale(d.point) + ", 0)";
    });
    group.attr("transform", function (d) {
      return "translate(" + xScale(d.point) + ", 0)";
    });
    group.exit().remove();
    bars = group.selectAll("rect").data(function (d) {
      return d.values;
    }).attr("id", "");
    bars.enter().append("rect").attrs({
      width: x0Scale.rangeBand(),
      x: function x(d) {
        var x0Value = _this.get('allowDuplicateDataGroups') ? d.series + d.index : d.series;
        return x0Scale(x0Value) + barPadding / 2;
      },
      y: function y(d) {
        return yScale(Math.max(0, d.value));
      },
      height: function height(d) {
        return Math.abs(yScale(0) - yScale(d.value));
      },
      opacity: this.get("hideBars") ? 0 : 0.8,
      fill: fill.bind(this)
    }).on("mouseover", this.get("dispatch").hover).on("mouseout", this.get("dispatch").mouseout).on("click", this.get("dispatch").click);
    bars.attrs({
      width: x0Scale.rangeBand(),
      x: function x(d) {
        var x0Value = _this.get('allowDuplicateDataGroups') ? d.series + d.index : d.series;
        return x0Scale(x0Value) + barPadding / 2;
      },
      y: function y(d) {
        return yScale(Math.max(0, d.value));
      },
      height: function height(d) {
        return Math.abs(yScale(0) - yScale(d.value));
      },
      opacity: this.get("hideBars") ? 0 : 0.8,
      fill: fill.bind(this)
    });
    bars.exit().remove();
  },

  /**
   * Draws the axes into the canvas and its labels.
   */
  drawAxes: function drawAxes() {
    var axes = this.get("axes");
    var canvas = this.get("canvas");
    canvas.drawAxes(axes);
    this.drawAxesLabels();
  },

  /**
   * Appends labels for Y axes and also appends the X axes sub labels.
   */
  drawAxesLabels: function drawAxesLabels() {
    var canvas = this.get("canvas");
    var y1LabelText = this.get("y1AxisLabel");
    var y2LabelText = this.get("y2AxisLabel");
    canvas.layer("".concat(Classes.AXES, "-labels"), "axes").remove();
    canvas.layer("".concat(Classes.AXES, "-xlabels"), "axes").remove();
    var layer = canvas.layer("".concat(Classes.AXES, "-labels"), "axes");
    var xlayer = canvas.layer("".concat(Classes.AXES, "-xlabels"), "axes");
    var xScale = this.get("scales").scale("x");
    var xAxisOrient = this.get("xAxisOrient");
    var xLabels = this.get("xAxisLabels");
    var xTexts;
    var adjustCanvasHeight;
    var canvasHeight = this.canvasHeight();

    if (this.get("wrapXAxisLabels") === true) {
      adjustCanvasHeight = this.get("_wrapXAxisLabelsCanvasAdjustment");
    }

    if (y1LabelText) {
      this.appendYLabel(layer, "y1", y1LabelText, adjustCanvasHeight);
    }

    if (this.get("y2") && y2LabelText) {
      this.appendYLabel(layer, "y2", y2LabelText, adjustCanvasHeight);
    }

    var isDateXAxis = this.get('xAxisDateLabel'); // X sub labels

    var shouldShowLabels = (canvas.get("outerWidth") > this.get("breakpoint") || this.get('showSubLabelsAtBreakpoint')) && xLabels;

    if (shouldShowLabels) {
      xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
      xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
        var x = xScale(d) + xScale.rangeBand() / 2;
        var y = xAxisOrient === "bottom" ? canvasHeight + 35 : -25;
        return "translate(".concat(x, ", ").concat(y, ")");
      }).append("text").text(function (d, i) {
        var label = "";

        if (i < xLabels.length) {
          label = xLabels[i] || "";
        }

        return label;
      }).attrs({
        "text-anchor": "middle"
      });
    }

    if (isDateXAxis) {
      this.get("dateAxis").drawSubLabels(canvas);
    }
  },

  /**
   * This method draws the backgroud grid in the chart.
   */
  drawGrid: function drawGrid() {
    var scales = this.get("scales");
    var y1Scale = scales.scale("y1");
    var xScale = scales.scale("x");
    var y1Axis = this.get("axes").axis("y1");
    var canvas = this.get("canvas");
    var tickValues = y1Axis.tickValues();
    var backGroup = canvas.get("backGroup");
    var yValue = this.canvasHeight();
    var grid = backGroup.selectAll(".".concat(Classes.GRID_LINE)).data(tickValues);
    var bottomLines;
    var hiddenBars = this.get("hideBars");
    var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");
    var padding = this.get("barGroupPadding");

    if (this.get("showGrayBands")) {
      this.drawGrayBands();
    }

    var extractor = function extractor(d) {
      return y1Scale(d);
    };

    var showZeroLine = this.get("showZeroLine");
    grid.enter().append("line").attrs({
      x1: 0 + padding,
      x2: canvas.width() - padding,
      y1: extractor,
      y2: extractor,
      class: function _class(d, i) {
        var appendClass = "";

        if (i === 0) {
          appendClass = "first";
        }

        if (i === tickValues.length - 1) {
          appendClass = "last";
        }

        return "".concat(Classes.GRID_LINE, " ").concat(appendClass);
      },
      opacity: function opacity(d, i) {
        if (isSmallHeight) {
          // if container's height is small, only show last grid line
          return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
        } else {
          return (!showZeroLine && d === 0 || i === 0) && !hiddenBars ? 0 : 1;
        }
      }
    });
    grid.attrs({
      x1: 0 + padding / 2,
      x2: canvas.width() - padding / 2,
      y1: extractor,
      y2: extractor,
      opacity: function opacity(d, i) {
        if (isSmallHeight) {
          // if container's height is small, only show last grid line
          return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
        } else {
          return (!showZeroLine && d === 0 || i === 0) && !hiddenBars ? 0 : 1;
        }
      }
    });
    grid.exit().remove(); // Draw bottom lines

    if (y1Scale.domain()[0] < 0) {
      bottomLines = backGroup.selectAll(".bottom-line").data(xScale.domain());
      var linesGap = this.get("showGrayBands") ? 0 : this.get("barGroupPadding");
      bottomLines.enter().append("line").classed("bottom-line", true).attr({
        x1: function x1(d) {
          return xScale(d) + linesGap / 2;
        },
        x2: function x2(d) {
          return xScale(d) + xScale.rangeBand() - linesGap / 2;
        },
        y1: yValue,
        y2: yValue
      });
      bottomLines.classed("bottom-line", true).attr({
        x1: function x1(d) {
          return xScale(d) + linesGap / 2;
        },
        x2: function x2(d) {
          return xScale(d) + xScale.rangeBand() - linesGap / 2;
        },
        y1: yValue,
        y2: yValue
      });
      bottomLines.exit().remove();
    }
  },
  drawGrayBands: function drawGrayBands() {
    var xScale = this.get("scales").scale("x");
    var canvas = this.get("canvas");
    var canvasHeight = this.canvasHeight();
    var backGroup = canvas.get("backGroup");
    var barPadding = this.get("barGroupPadding");
    var length = xScale.domain().length; //draw back ground bars

    var gridBars = backGroup.selectAll(".grid-bar").data(xScale.domain());
    gridBars.enter().append("rect").classed("grid-bar", true).attr({
      x: function (d, i) {
        return i === 0 ? xScale(d) + barPadding / 2 : xScale(d);
      }.bind(this),
      y: 0,
      width: function width(d, i) {
        return i === 0 || i === length - 1 ? xScale.rangeBand() - barPadding / 2 : xScale.rangeBand();
      },
      height: canvasHeight
    });
    gridBars.classed("grid-bar", true).attr({
      x: function (d, i) {
        return i === 0 ? xScale(d) + barPadding / 2 : xScale(d);
      }.bind(this),
      y: 0,
      width: function width(d, i) {
        return i === 0 || i === length - 1 ? xScale.rangeBand() - barPadding / 2 : xScale.rangeBand();
      },
      height: canvasHeight
    });
    gridBars.exit().remove();
  },

  /**
   * Configure all axes used in the chart.
   */
  buildAxes: function buildAxes() {
    var _this = this;

    var scales = this.get("scales");
    var axes = this.get("axes");
    var calculatedTicks = Utils.chart.getTickValues(this.get("_yDomain"), this.get("ticksNumber"));
    var tickValues = this.get("tickValues") || calculatedTicks;
    var tickValues2, y2axis;

    var tickFormat = function tickFormat(symbol, length, formatFn) {
      return function (d, i) {
        var value = _this.tickFormat(formatFn)(d);

        value = Utils.string.convertDashToEnDash(value);
        return symbol && i === length - 1 ? symbol + value : value;
      };
    };

    var xAxis = d3.svg.axis().scale(scales.scale("x")).orient(this.get("xAxisOrient")).tickFormat(function (d) {
      return Utils.string.unmask(d);
    });

    if (this.get('xAxisDateLabel')) {
      xAxis = this.get('dateAxis').getAxis();
    }

    var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), tickValues.length, this.get("y1TickFormat")));
    yAxis.axisLabel = this.get("y1AxisLabel");
    axes.axis("x", xAxis);
    axes.axis("y1", yAxis);

    if (this.get("y2")) {
      tickValues2 = Utils.chart.getTickValues(this.get("y2Domain"));
      y2axis = d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues2).tickFormat(tickFormat(this.get("y2TickSymbol"), tickValues2.length, this.get("y2TickFormat")));
      axes.axis("y2", y2axis);
    }
  },

  /**
   * Creates the chart scales
   */
  buildScales: function buildScales() {
    var scales = this.get("scales");
    var canvas = this.get("canvas");
    var xScale = d3.scale.ordinal().domain(this.get("xDomain")).rangeBands([0, canvas.width()], 0.00);

    if (this.get('xAxisDateLabel')) {
      var dateAxis = new DateAxis({
        domain: this.get('xDomain'),
        range: [0, this.get("canvas").width()],
        timeLevel: this.get('timeLevel'),
        orient: this.get('xAxisOrient')
      });
      this.set('dateAxis', dateAxis);
      this.set('xAxisLabels', dateAxis.get('subLabels'));
      xScale = dateAxis.getScale();
    }

    var yScale = d3.scale.linear().domain(this.get("_yDomain")).range([this.canvasHeight(), 0]);
    var x0Scale = d3.scale.ordinal().domain(this.get("x0Domain")).rangeBands([0, xScale.rangeBand() - this.get("barGroupPadding")]);
    scales.scale("x", xScale);
    scales.scale("y1", yScale);
    scales.scale("x0", x0Scale);

    if (this.get("y2")) {
      scales.scale("y2", d3.scale.linear().domain(this.get("y2Domain")).range([this.canvasHeight(), 0]));
    }
  },

  /**
   * Returns the X0 domain used in the grouped bar chart groups.
   */
  getX0Domain: function getX0Domain() {
    var _this = this;

    return this.get("data").get(this.get("y1DataSource"))[0].values.map(function (value) {
      var groupID = _this.get('allowDuplicateDataGroups') ? value.series + value.index : value.series;
      return groupID;
    });
  },

  /**
   * Sets the margin depending on the chart configuration.
   */
  getMargins: function getMargins() {
    var xAxisOrient = this.get("xAxisOrient");
    var xAxisLabels = this.get("xAxisLabels");
    var y1AxisOrient = this.get("y1AxisOrient");
    var y2AxisOrient = this.get("y2AxisOrient");
    var yTickSize = this.get("yTickSize");
    var canvas = this.get("canvas");
    var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
    var yAxesSpacing = this.get("yAxesSpacing");
    var y1AxisLabel = this.get("y1AxisLabel");
    var yPadding = this.get("yPadding");
    var y1Width = !y1AxisLabel ? yTickSize + yPadding : yTickSize + yPadding + yAxesLabelWidth;
    var y2AxisLabel, y2Width;
    var margin = {
      top: xAxisOrient === "top" ? 30 : 5,
      right: y1AxisOrient === "right" ? y1Width + yPadding : yPadding,
      bottom: xAxisOrient === "bottom" ? 25 : 1,
      left: y1AxisOrient === "left" ? y1Width : 0
    };

    if (this.get("y2")) {
      y2AxisLabel = this.get("y1AxisLabel");
      y2Width = !y2AxisLabel ? yTickSize : yTickSize + yAxesLabelWidth;

      if (y1AxisOrient === "left" && y2AxisOrient === "left") {
        margin.left += y2Width + yAxesSpacing;
      } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
        margin.right += y2Width + yAxesSpacing;
      } else {
        margin.right += y2Width + yPadding;
      }
    }

    if (xAxisLabels && xAxisOrient === "top") {
      margin.top += 15;
    } else if (xAxisLabels && xAxisOrient === "bottom") {
      margin.bottom += 15;
    }

    return margin;
  },

  /**
   * Check for responsive breakpoints
   */
  checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
    var dw = newValue > oldValue;
    var breakpoint = this.get("breakpoint");

    if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
      this.redoCanvas();
    }
  },

  /**
   * Sets the canvas template depending on the lengend position.
   */
  setCanvasTemplate: function setCanvasTemplate(width) {
    var template;

    if (this.get("legend")) {
      if (width > this.get("breakpoint")) {
        template = "<div class=\"".concat(Classes.INNER, " ").concat(Classes.INNER, "-right\"></div>\n                    <div class=\"").concat(Classes.LEGEND, " ").concat(Classes.LEGEND, "-right\"><div class=\"").concat(Classes.LEGEND, "-inner\"></div></div>");
      } else {
        template = "<div class=\"".concat(Classes.LEGEND, " ").concat(Classes.LEGEND, "-top\"><div class=\"").concat(Classes.LEGEND, "-inner\"></div></div>\n                <div class=\"").concat(Classes.INNER, " ").concat(Classes.INNER, "-top\"></div>");
      }
    }

    this.set("canvasTemplate", template);
  },

  /**
   * Returns the bar padding.
   */
  setBarGroupPadding: function setBarGroupPadding() {
    var data = this.get("data").get(this.get("y1DataSource"));
    var l = data.length;
    var type, length;

    if (this.get("stacked")) {
      type = "standard";
      length = l;
    } else {
      type = "grouped";
      length = l * data[0].values.length;
    }

    var width = this.get("canvas").width();
    var padding = Utils.chart.getBarPadding(length, width, "vertical", type);
    this.set("barGroupPadding", padding);
  },

  /**
   * @override
   */
  beforeCanvas: function beforeCanvas(selection) {
    this.setCanvasTemplate(selection[0][0].offsetWidth);
  },

  /**
   * Force the canvas to be created again using the intended template.
   */
  redoCanvas: function redoCanvas() {
    var canvas = this.get("canvas");
    canvas.remove();
    this.setCanvasTemplate();

    this._createCanvas();
  },

  /**
   * Reloads all the chart's data.
   * @param {Object} dataset Initial dataset object.
   */
  data: function data(dataset) {
    this.get("data").clean();
    this.setData(dataset);
    this.update();
    return this;
  },

  /**
   * Add a series to the bar chart
   * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
   * @example
   * chart.add({
   *      name: "Apple Inc.",
   *      values: [123.5, 56, 34, 54]
   * })
   */
  add: function add(series) {
    this.get("data").set(series.name, series.values, this.get("y1DataSource"));
    this.update();
    return this;
  },

  /**
   * Add benchmarks replacing the existent ones
   * @param {Array} series Object {name: <name of the series>, values: <Array of values for the series>}
   */
  addBenchmark: function addBenchmark(benchmarks) {
    if (!benchmarks) return;
    var datasetName = this.get("benchmarksDataSource");
    var data = this.get("data");
    data.remove(datasetName);
    data.uset({
      name: datasetName,
      series: benchmarks,
      display: this.get("benchmarksDisplayName")
    });
    this.update();
    return this;
  },

  /**
   * Removes a series from the chart.
   * @param {String} seriesName Name of the series to remove from the chart.
   */
  remove: function remove(seriesName) {
    this.get("data").remove(seriesName);
    this.update();
    return this;
  }
});
module.exports = GroupedBarchart;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(39);

var Utils = Core.Utils;
var mbc_mds_constants = Utils.colors.mbc_mds_constants;

function BenchmarksMixin() {}
/**
 * This method draws the bar char benchmark lines.
 */


BenchmarksMixin.prototype.drawSegmentedBenchmarks = function (benchmarksData) {
  var height = this.get("benchmarksHeight");
  var data = benchmarksData[0];
  var scales = this.get("scales");
  var xScale = scales.scale("x");
  var yScale = scales.scale("y1");
  var layer = this.get("canvas").layer("layer-benchmarks");
  var benchmarks = layer.selectAll(".benchmark").data(data.series);
  var barPadding = this.get("barGroupPadding");
  var barWidth = xScale.rangeBand() - barPadding;

  var x = function x(d, i) {
    return xScale(xScale.domain()[i]) + barPadding / 2;
  };

  var y = function y(d) {
    return yScale(d) - Math.floor(height / 2);
  };

  var h = function h(d) {
    return d === null ? 0 : height;
  };

  benchmarks.enter().append("rect").classed("benchmark", true).attrs({
    width: barWidth,
    height: h,
    x: x,
    y: y,
    fill: this.get("dottedBenchmarks") ? 'none' : this.get("benchmarksColor")
  }).on("mouseover", this.get("dispatch").hover);
  benchmarks.attrs({
    width: barWidth,
    height: h,
    x: x,
    y: y,
    fill: this.get("dottedBenchmarks") ? 'none' : this.get("benchmarksColor")
  });
  benchmarks.exit().remove();

  if (this.get("dottedBenchmarks")) {
    benchmarks.attr("stroke-dasharray", this.get("dottedDashDimensions"));
    benchmarks.attr("stroke-linecap", "round");
    benchmarks.attr("stroke-width", this.get("dottedStrokeWidth"));
    benchmarks.attr("stroke", this.get("benchmarksColor"));
  }
};

BenchmarksMixin.prototype.drawBenchmarks = function (benchmarksData) {
  var height = this.get("benchmarksHeight");
  var data = benchmarksData;
  var scales = this.get("scales");
  var xScale = scales.scale("x");
  var yScale = scales.scale("y1");
  var layer = this.get("canvas").layer("layer-benchmarks");
  var xoffset = xScale.rangeBand() / 2;
  var benchmarkDots = layer.selectAll(".benchmarkDot").data(data[0].series);

  var r = function r(d) {
    return d === null ? 0 : 3.5;
  };

  benchmarkDots.enter().append("circle").classed("benchmarkDot", true).attr("cx", function (d, i) {
    return xScale(xScale.domain()[i]) + xoffset;
  }).attr("cy", function (d) {
    return yScale(d) - Math.floor(height / 2);
  }).attr("r", r).attr("fill", "black");
  benchmarkDots.classed("benchmarkDot", true).attr("cx", function (d, i) {
    return xScale(xScale.domain()[i]) + xoffset;
  }).attr("cy", function (d) {
    return yScale(d) - Math.floor(height / 2);
  }).attr("r", r).attr("fill", "black");
  benchmarkDots.exit().remove();

  var generateLine = function generateLine(list) {
    var height = this.get("benchmarksHeight");
    var scales = this.get("scales");
    var xScale = scales.scale("x");
    var yScale = scales.scale("y1");
    var xoffset = xScale.rangeBand() / 2;
    var path = "";
    var hasStartedMoving = false;

    for (var i = 0; i < list.length; i++) {
      var value = list[i];

      if (value !== null) {
        var x = xScale(xScale.domain()[i]) + xoffset,
            y = yScale(value) - Math.floor(height / 2);
        var currentCoordinate = !hasStartedMoving ? "M" + x + "," + y : "L" + x + "," + y;
        hasStartedMoving = true;
        path += currentCoordinate;
      }
    }

    return path;
  };

  var linePath = generateLine.call(this, data[0].series);
  var benchmarks = layer.selectAll(".line").data(data);
  benchmarks.enter().append("path").classed("line", true).attr("d", linePath).attr("stroke", mbc_mds_constants["color"].black).attr("stroke-width", 2).attr("fill", "none").on("mouseover", this.get("dispatch").hover);
  benchmarks.classed("line", true).attr("d", linePath).attr("stroke", mbc_mds_constants["color"].black).attr("stroke-width", 2).attr("fill", "none");
  benchmarks.exit().remove();

  if (this.get("dottedBenchmarks")) {
    benchmarks.attr("stroke-dasharray", this.get("dottedDashDimensions"));
    benchmarks.attr("stroke-linecap", "round");
    benchmarks.attr("stroke-width", this.get("dottedStrokeWidth"));
  }
};

module.exports = BenchmarksMixin;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(96);

__webpack_require__(113);

__webpack_require__(40);

__webpack_require__(85);

__webpack_require__(81);

var Utils = __webpack_require__(39).Utils;

var TooltipPlugin = __webpack_require__(93);

var mbc_mds_constants = Utils.colors.mbc_mds_constants;

function Tooltip() {}

;
/**
 * Initializes the tooltip.
 */

Tooltip.prototype.initTooltip = function () {
  var benchmarks = this.get('data').get(this.get('benchmarksDataSource'));
  var barsHidden = this.get('hideBars');
  this.resetZones();

  if (!barsHidden || barsHidden && benchmarks.length) {
    this.addTooltipZones();
    this.addTooltip();
  }
};
/**
 * Create a new Tooltip Plugin object and it is binded to the chart hovering zones.
 */


Tooltip.prototype.addTooltip = function () {
  var canvas = this.get('canvas');
  var selection = canvas.layer('mbc-bar-chart-tooltip', 'front').selectAll('.mbc-bar-chart-tooltip-zone');
  var tooltip = TooltipPlugin({
    namespace: this.get('id'),
    autoposition: this.get('canvas')
  }).template(this.getTemplateFunction().bind(this));
  selection.call(tooltip.bind());
  this.set('tooltipObject', tooltip);
};
/**
 * Highlights hover over each group or bars
 */


Tooltip.prototype.toggleHighlight = function (index) {
  var grouped = this.get("selection").selectAll(".bar-group")[0];
  grouped.forEach(function (bar, i) {
    if (i === index) {
      var n = bar.childNodes.length;

      for (var j = 0; j < n; j++) {
        var rect = bar.childNodes[j];

        if (rect.id === "highlighted") {
          rect.removeAttribute("id");
        } else {
          rect.id = "highlighted";
        }
      }
    }
  });
};
/**
 * Adds the mouse hover zones to trigger the tooltip.
 */


Tooltip.prototype.addTooltipZones = function () {
  var canvas = this.get("canvas");
  var nullValueDisplay = this.get("tooltipNullValueDisplay");
  var data = this.get("dataForTooltips");
  var benchmarks = this.get("data").get(this.get("benchmarksDataSource"));
  var scales = this.get("scales");
  var xScale = scales.scale("x");
  var rangeBand = xScale.rangeBand();
  var benchmarkColor = this.get("benchmarksColor");
  var layer, benchmarksName;
  var formatFn = this.tickFormat(this.get("y1TickFormat"));
  var hiddenBars = this.get("hideBars");
  var padding = this.get("barGroupPadding");

  var x = function x(d, i) {
    // bar-group has a transform that shifts elements, must include this translation when using the retrieved padding value
    return xScale(xScale.domain()[i]) + padding / 2;
  };

  canvas.removeLayer("mbc-bar-chart-tooltip", "front");
  layer = canvas.layer("mbc-bar-chart-tooltip", "front");

  if (benchmarks.length) {
    benchmarksName = benchmarks[0].displayName;
    benchmarks = benchmarks[0].series;
    data.forEach(function (d, i) {
      var val = benchmarks[i];
      var isNull = val === null || typeof val === "undefined";
      d.benchmark = {
        name: benchmarksName,
        value: isNull ? nullValueDisplay : Utils.string.convertDashToEnDash(formatFn(val)),
        oValue: val,
        color: benchmarkColor,
        benchmark: true
      };
    });
  }

  var zones = layer.selectAll(".mbc-bar-chart-tooltip-zone").data(data);
  var canvasHeight = this.canvasHeight(); // Enter

  zones.enter().append("rect").classed("mbc-bar-chart-tooltip-zone", true).attrs({
    opacity: 0,
    width: rangeBand - padding,
    height: canvasHeight,
    x: x,
    y: 0
  }).on("mouseover", function (d, i) {
    if (!hiddenBars) {
      this.toggleHighlight(i);
    }
  }.bind(this)).on("mouseout", function (d, i) {
    if (!hiddenBars) {
      this.toggleHighlight(i);
    }
  }.bind(this));
};
/**
 * @method resetZones
 * @desc Clear all the tooltip zones
 * @return undefined
 */


Tooltip.prototype.resetZones = function () {
  var canvas = this.get("canvas");
  var layer = canvas.layer("mbc-bar-chart-tooltip", "front");
  layer.selectAll('rect').remove();
};

Tooltip.prototype.formatData = function (d) {
  var _this = this;

  var dataMan = this.get('data');
  var nullValueDisplay = this.get('tooltipNullValueDisplay');
  var y1DS = this.get('y1DataSource');
  var context = Utils.assign({}, this.__attributes);
  var seriesData = [];
  var positive = [];
  var negative = [];
  var colorFn = this.color.bind(this);

  var y1TickFormat = _this.tickFormat(_this.get('y1TickFormat'));

  var y2TickFormat = _this.tickFormat(_this.get('y2TickFormat'));

  var datapoint = Utils.string.unmask(d.point);

  if (this.get('xAxisDateLabel')) {
    var format = this.get('tooltipTimeFormat') || d3.time.format('%x');
    datapoint = format(new Date(datapoint));
  }

  context.datapoint = datapoint;
  var barsHidden = this.get('hideBars');

  if (!barsHidden) {
    d.values.forEach(function (value) {
      var formatFn = dataMan.inGroup(value.series, y1DS) ? y1TickFormat : y2TickFormat;
      var val = value.value;
      var isNull = val === null || typeof val === 'undefined';
      var item = {
        name: value.series,
        value: isNull ? nullValueDisplay : Utils.string.convertDashToEnDash(formatFn(val)),
        oValue: val,
        color: colorFn(value.index),
        benchmark: false
      };
      seriesData.push(item);

      if (val >= 0) {
        positive.unshift(item);
      } else {
        negative.push(item);
      }
    });

    if (this.get('stacked')) {
      seriesData = positive.concat(negative);
    }
  }

  if (d.benchmark) {
    seriesData.push(d.benchmark);
  }

  context.data = seriesData;
  var longestValue = Utils.string.getLongestTextStringWidth(context.data);
  context.maxWidthTextCell = 164 - longestValue; // 200 max width - 10 icon with - 26 in total padding

  return context;
};
/**
 * Returns defined template or function for tooltip data.  Use default template function if none defined.
 * @returns {function}
 */


Tooltip.prototype.getTemplateFunction = function () {
  var hasCustomTemplateFunction = typeof this.get('tooltipTemplateFunction') === 'function';

  if (hasCustomTemplateFunction) {
    return this.applyTemplateFunction;
  }

  return this.get('tooltipTemplate') ? this.compileTemplate : this.defaultTemplate;
};
/**
 * Compiles the template against a context and returns the HTML String.
 * @param data
 * @returns {*}
 */


Tooltip.prototype.compileTemplate = function (data) {
  var template = this.get('tooltipTemplate');
  var context = this.formatData(data);
  return Utils.string.template(template, context);
};
/**
 * Apply default template to selection data
 * @param d
 * @returns {string}
 */


Tooltip.prototype.defaultTemplate = function (d) {
  var _this2 = this;

  var context = this.formatData(d);
  var templateArray = [];
  templateArray.push("<div class=\"tooltip-inner tooltip-flag\">");
  templateArray.push("<div class=\"tooltip-title\"><p>".concat(context.datapoint, "</p></div>"));
  templateArray.push('<div class="tooltip-body tooltip-table">');
  context.data.forEach(function (x) {
    templateArray.push('<div class="cell tooltip-row">');
    var classes = ['tip-cell-icon', 'tooltip-cell'];
    var styles = [];

    if (x.benchmark) {
      classes.push('benchmark');
      styles.push('height: 2px;');
      styles.push('margin-bottom: 3px;');
    }

    if (!x.benchmark || !_this2.dottedBenchmarks) {
      styles.push("background-color: ".concat(x.color, ";"));
    } else {
      styles.push("background-color: transparent;");
      styles.push("border-top: 2px dotted ".concat(mbc_mds_constants["color"].black, ";"));
    }

    templateArray.push("<div class=\"".concat(classes.join(' '), "\" style=\"").concat(styles.join(' '), "\"></div>"));
    templateArray.push("<div class=\"tip-cell-name tooltip-cell\" style=\"max-width: ".concat(_this2.maxWidthTextCell, "px\">").concat(x.name, "</div>"));
    templateArray.push("<div class=\"tip-cell-name tooltip-cell\">".concat(x.value, "</div>"));
    templateArray.push('</div>');
  });
  templateArray.push('</div></div>');
  return templateArray.join('');
};
/**
 * Applies custom template function to selection data
 * @param d
 * @returns {*}
 */


Tooltip.prototype.applyTemplateFunction = function (d) {
  var customTemplateFunction = this.get('tooltipTemplateFunction');
  var data = this.formatData(d);
  return customTemplateFunction(data);
};

module.exports = Tooltip;

/***/ })
/******/ ]);
});